module.exports = __webpack_public_path__ + "img/1.d3a770c2.jpg";